var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm.value.countryId == 12
          ? [
              _c("div", { staticClass: "col-12" }, [
                _c("h5", [
                  _vm._v(
                    "\n          Only corporate customers are eligible for purchases requiring delivery to the UK, we apologize for the inconvenience.\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn my-2 btn-primary btn-appearance btn-block",
                      class: [
                        { activeGender: _vm.value.gender == "company" },
                        { genderBtn: _vm.value.gender != "company" }
                      ],
                      on: {
                        click: function($event) {
                          _vm.value.gender = "company"
                        }
                      }
                    },
                    [_vm._v("\n            Company\n          ")]
                  )
                ])
              ])
            ]
          : [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row pb-3" }, [
                  _c("div", { staticClass: "col-md-3 mb-3 col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn  btn-primary btn-appearance btn-block",
                        class: [
                          { activeGender: _vm.value.gender == "company" },
                          { genderBtn: _vm.value.gender != "company" }
                        ],
                        on: {
                          click: function($event) {
                            _vm.value.gender = "company"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.addressSalutationCompany"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3 mb-3 col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-appearance btn-block",
                        class: [
                          { activeGender: _vm.value.gender == "male" },
                          { genderBtn: _vm.value.gender != "male" }
                        ],
                        on: {
                          click: function($event) {
                            _vm.value.gender = "male"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.addressSalutationMale"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3 col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-appearance btn-block",
                        class: [
                          { activeGender: _vm.value.gender == "female" },
                          { genderBtn: _vm.value.gender != "female" }
                        ],
                        on: {
                          click: function($event) {
                            _vm.value.gender = "female"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.addressSalutationFemale"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3 col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-appearance btn-block",
                        class: [
                          { activeGender: _vm.value.gender == "diverse" },
                          { genderBtn: _vm.value.gender != "diverse" }
                        ],
                        on: {
                          click: function($event) {
                            _vm.value.gender = "diverse"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.addressSalutationDiverse"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ],
        _vm._v(" "),
        _vm.addressType === "1"
          ? [
              _vm.value.countryId == 12
                ? [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "input-unit",
                              attrs: {
                                "data-validate": "text",
                                "data-model": "name1"
                              }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "company",
                                  id: "txtCompany" + _vm._uid,
                                  "data-autofocus": "",
                                  maxlength: "30"
                                },
                                domProps: { value: _vm.value.name1 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "name1",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtCompany" + _vm._uid } },
                                [_vm._v("COMPANY*")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.name1
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m--t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.name1.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.value.name1.length)
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:regex",
                                  value: _vm.vatnumberValidateExpression,
                                  expression: "vatnumberValidateExpression",
                                  arg: "regex"
                                }
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "vatNumber" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "vatNumber",
                                  id: "txtVatNumber" + _vm.value.countryId,
                                  "data-validate-ref":
                                    _vm.vatnumberValidateExpression,
                                  "data-autofocus": ""
                                },
                                domProps: { value: _vm.value.vatNumber },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "vatNumber",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "txtVatNumber" + _vm.value.countryId
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  VAT NUMBER  *\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: true,
                                  expression: "true",
                                  arg: "text"
                                }
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name2" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "firstName",
                                  id: "txtFirstName" + _vm._uid,
                                  "data-model": "name2",
                                  "data-autofocus": ""
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [_vm._v("First Name *")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.name2
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m--t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.name2.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.value.name2.length)
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: true,
                                  expression: "true",
                                  arg: "text"
                                }
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name3" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "lastName",
                                  id: "txtLastName" + _vm._uid,
                                  "data-model": "name3"
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [_vm._v("Last Name *")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.name3
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m--t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.name3.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.value.name3.length)
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:regex",
                                  value:
                                    _vm.EoriValidateExpression["expression"],
                                  expression:
                                    "EoriValidateExpression['expression']",
                                  arg: "regex"
                                }
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "address4" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "decorateAddress",
                                  id: "decorateAddress1" + _vm._uid,
                                  "data-validate-ref":
                                    _vm.EoriValidateExpression["expression"],
                                  "data-autofocus": ""
                                },
                                domProps: { value: _vm.value.address4 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "address4",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: { for: "decorateAddress1" + _vm._uid }
                                },
                                [
                                  _vm._v(
                                    "\n                  EORI NUMBER *\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: true,
                                  expression: "true",
                                  arg: "text"
                                }
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "telephone" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "telephone",
                                  id: "txtTelephone" + _vm._uid
                                },
                                domProps: { value: _vm.value.telephone },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "telephone",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtTelephone" + _vm._uid } },
                                [
                                  _vm._v(
                                    "\n                  Phonenumber *\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-sm-8" }, [
                          _c(
                            "div",
                            {
                              staticClass: "input-unit",
                              attrs: {
                                "data-validate": "text",
                                "data-model": "address1"
                              }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "street",
                                  autocomplete: "address-line1",
                                  id: "txtStreet" + _vm._uid,
                                  maxlength: "30"
                                },
                                domProps: { value: _vm.value.address1 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "address1",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtStreet" + _vm._uid } },
                                [_vm._v("STREET*")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.address1
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m-t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.address1.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.value.address1.length
                                      )
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "input-unit",
                              attrs: { "data-model": "address2" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "housenumber",
                                  autocomplete: "address-line2",
                                  id: "txtNumber" + _vm._uid,
                                  maxlength: "30"
                                },
                                domProps: { value: _vm.value.address2 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "address2",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtNumber" + _vm._uid } },
                                [
                                  _vm._v(
                                    "\n                  HOUSE NO.*\n                "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.address2
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m--t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.address2.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.value.address2.length
                                      )
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-sm-12" }, [
                          _c(
                            "div",
                            {
                              staticClass: "input-unit",
                              attrs: { "data-model": "address3" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "buildingName",
                                  id: "decorateAddress0" + _vm._uid,
                                  maxlength: "30"
                                },
                                domProps: { value: _vm.value.address3 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "address3",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: { for: "decorateAddress0" + _vm._uid }
                                },
                                [
                                  _vm._v(
                                    "\n                  Address Line 3\n                "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.address3
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m--t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.address3.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.value.address3.length
                                      )
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-validate": "text",
                            "data-model": "town"
                          }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "town",
                              id: "txtPlace" + _vm._uid
                            },
                            domProps: { value: _vm.value.town },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "town",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtPlace" + _vm._uid } },
                            [_vm._v("TOWN*")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-validate": "text",
                            "data-model": "postalCode"
                          }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "zip",
                              id: "txtZip" + _vm._uid
                            },
                            domProps: { value: _vm.value.postalCode },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "postalCode",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                            _vm._v("POSTOCDE*")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._t("custom-address-fields")
                  ]
                : [
                    _vm.value.showPickupStation &&
                    _vm.selectedCountry.isoCode2 === "DE"
                      ? [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _vm.value.gender === "company"
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "input-unit",
                                          attrs: {
                                            "data-model": "name1",
                                            "data-validate": "text"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "text",
                                              name: "company",
                                              id: "txtCompany" + _vm._uid
                                            },
                                            domProps: {
                                              value: _vm.value.name1
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.emitInputEvent(
                                                  "name1",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "txtCompany" + _vm._uid
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.addressCompany"
                                                  )
                                                ) + "*"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-4" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate:text",
                                        value: true,
                                        expression: "true",
                                        arg: "text"
                                      }
                                    ],
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "name2" }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "firstName",
                                        id: "txtFirstName" + _vm._uid
                                      },
                                      domProps: { value: _vm.value.name2 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "name2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "txtFirstName" + _vm._uid
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressFirstName"
                                            )
                                          ) + "*"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.value.name2
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-right d-block m--t-1",
                                        class: {
                                          "red font-weight-bold":
                                            _vm.value.name2.length == 30
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.value.name2.length
                                            )
                                          }
                                        }),
                                        _vm._v(" / 30")
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-4" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate:text",
                                        value: true,
                                        expression: "true",
                                        arg: "text"
                                      }
                                    ],
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "name3" }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "lastName",
                                        id: "txtLastName" + _vm._uid
                                      },
                                      domProps: { value: _vm.value.name3 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "name3",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "txtLastName" + _vm._uid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressLastName"
                                            )
                                          ) + " * "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.value.name3
                                ? _c(
                                    "small",
                                    {
                                      staticClass: "text-right d-block m--t-1",
                                      class: {
                                        "red font-weight-bold":
                                          _vm.value.name3.length == 30
                                      }
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.value.name3.length
                                          )
                                        }
                                      }),
                                      _vm._v(" / 30")
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-4" }, [
                                _vm.value.countryId != 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "input-unit",
                                        attrs: { "data-model": "telephone" }
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "text",
                                            name: "telephone",
                                            id: "txtTelephone" + _vm._uid
                                          },
                                          domProps: {
                                            value: _vm.value.telephone
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.emitInputEvent(
                                                "telephone",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "txtTelephone" + _vm._uid
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.transformTranslation(
                                                    "Ceres::Template.addressTelephone",
                                                    "de",
                                                    "delivery_address.phoneNumber"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.isParcelOrOfficeAvailable
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        name: "togglePickup",
                                        id: "showPickup" + _vm._uid
                                      },
                                      domProps: {
                                        checked: _vm.value.showPickupStation
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.togglePickupStation(
                                            $event.target.checked
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "showPickup" + _vm._uid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressToPickupStation"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-8" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "address1" }
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        staticClass: "custom-select",
                                        domProps: { value: _vm.value.address1 },
                                        on: {
                                          change: function($event) {
                                            return _vm.emitInputEvent(
                                              "address1",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm.isParcelBoxAvailable ||
                                        _vm.isMyAccount
                                          ? _c(
                                              "option",
                                              {
                                                attrs: { value: "PACKSTATION" },
                                                domProps: {
                                                  selected: _vm.isPickupStation
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.addressPackingStation"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isPostOfficeAvailable ||
                                        _vm.isMyAccount
                                          ? _c(
                                              "option",
                                              {
                                                attrs: { value: "POSTFILIALE" },
                                                domProps: {
                                                  selected: _vm.isPostOffice
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.addressPostOffice"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.addressPickupLocation"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-unit",
                                    attrs: {
                                      "data-validate": "text",
                                      "data-model": "address2"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "housenumber",
                                        autocomplete: "address-line2",
                                        id: "txtNumber" + _vm._uid
                                      },
                                      domProps: { value: _vm.value.address2 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "address2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.isPickupStation
                                      ? _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "txtNumber" + _vm._uid
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.addressPackingStationNumber"
                                                )
                                              ) + "*"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isPostOffice
                                      ? _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "txtNumber" + _vm._uid
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.addressPostOfficeNumber"
                                                )
                                              ) + "*"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-unit",
                                    attrs: {
                                      "data-validate": "text",
                                      "data-model": "postNumber"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "postnumber",
                                        id: "postnumber" + _vm._uid
                                      },
                                      domProps: { value: _vm.value.postNumber },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "postNumber",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "postnumber" + _vm._uid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressPostNummer"
                                            )
                                          ) + "*"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-unit",
                                attrs: {
                                  "data-validate": "text",
                                  "data-model": "postalCode"
                                }
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    type: "text",
                                    name: "zip",
                                    id: "txtZip" + _vm._uid
                                  },
                                  domProps: { value: _vm.value.postalCode },
                                  on: {
                                    input: function($event) {
                                      return _vm.emitInputEvent(
                                        "postalCode",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "txtZip" + _vm._uid } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressZip"
                                        )
                                      ) + "*"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-unit",
                                attrs: {
                                  "data-validate": "text",
                                  "data-model": "town"
                                }
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    type: "text",
                                    name: "town",
                                    id: "txtPlace" + _vm._uid
                                  },
                                  domProps: { value: _vm.value.town },
                                  on: {
                                    input: function($event) {
                                      return _vm.emitInputEvent(
                                        "town",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "txtPlace" + _vm._uid } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressPlace"
                                        )
                                      ) + "*"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._t("custom-address-fields")
                        ]
                      : [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _vm.value.gender === "company"
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "input-unit",
                                          attrs: {
                                            "data-validate": "text",
                                            "data-model": "name1"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "text",
                                              name: "company",
                                              id: "txtCompany" + _vm._uid,
                                              "data-autofocus": "",
                                              maxlength: "30"
                                            },
                                            domProps: {
                                              value: _vm.value.name1
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.emitInputEvent(
                                                  "name1",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "txtCompany" + _vm._uid
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.addressCompany"
                                                  )
                                                ) + "*"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.value.name1
                                        ? _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-right d-block m--t-1",
                                              class: {
                                                "red font-weight-bold":
                                                  _vm.value.name1.length == 30
                                              }
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.value.name1.length
                                                  )
                                                }
                                              }),
                                              _vm._v(" / 30")
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.value.gender === "company"
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-6" },
                                    [
                                      [
                                        3,
                                        44,
                                        7,
                                        9,
                                        11,
                                        12,
                                        10,
                                        13,
                                        16,
                                        15,
                                        54,
                                        18,
                                        33,
                                        17,
                                        19,
                                        21,
                                        2,
                                        23,
                                        22,
                                        41,
                                        24,
                                        26,
                                        27,
                                        8,
                                        6,
                                        14,
                                        5
                                      ].includes(_vm.selectedCountry.id)
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate:regex",
                                                    value:
                                                      _vm.vatnumberValidateExpression,
                                                    expression:
                                                      "vatnumberValidateExpression",
                                                    arg: "regex"
                                                  }
                                                ],
                                                staticClass: "input-unit",
                                                attrs: {
                                                  "data-model": "vatNumber"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "text",
                                                    name: "vatNumber",
                                                    id:
                                                      "txtVatNumber" +
                                                      _vm.value.countryId,
                                                    "data-validate-ref":
                                                      _vm.vatnumberValidateExpression,
                                                    "data-autofocus": ""
                                                  },
                                                  domProps: {
                                                    value: _vm.value.vatNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.emitInputEvent(
                                                        "vatNumber",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for:
                                                        "txtVatNumber" +
                                                        _vm.value.countryId
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.transformTranslation(
                                                            "Ceres::Template.addressVatNumber",
                                                            "de",
                                                            "billing_address.vatNumber"
                                                          )
                                                        ) +
                                                        "  *\n                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "input-unit",
                                                  attrs: {
                                                    "data-model": "vatNumber"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "text",
                                                      name: "vatNumber",
                                                      id:
                                                        "txtVatNumber" +
                                                        _vm.value.countryId,
                                                      "data-autofocus": ""
                                                    },
                                                    domProps: {
                                                      value: _vm.value.vatNumber
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.emitInputEvent(
                                                          "vatNumber",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for:
                                                          "txtVatNumber" +
                                                          _vm.value.countryId
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.transformTranslation(
                                                              "Ceres::Template.addressVatNumber",
                                                              "de",
                                                              "billing_address.vatNumber"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-6" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate:text",
                                        value: true,
                                        expression: "true",
                                        arg: "text"
                                      }
                                    ],
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "name2" }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "firstName",
                                        id: "txtFirstName" + _vm._uid,
                                        "data-autofocus": "",
                                        maxlength: "30"
                                      },
                                      domProps: { value: _vm.value.name2 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "name2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "txtFirstName" + _vm._uid
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressFirstName"
                                            )
                                          ) + "*"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.value.name2
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-right d-block m--t-1",
                                        class: {
                                          "red font-weight-bold":
                                            _vm.value.name2.length == 30
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.value.name2.length
                                            )
                                          }
                                        }),
                                        _vm._v(" / 30")
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-6" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate:text",
                                        value: true,
                                        expression: "true",
                                        arg: "text"
                                      }
                                    ],
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "name3" }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "lastName",
                                        id: "txtLastName" + _vm._uid,
                                        maxlength: "30"
                                      },
                                      domProps: { value: _vm.value.name3 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "name3",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "txtLastName" + _vm._uid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressLastName"
                                            )
                                          ) + " * "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.value.name3
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-right d-block m--t-1",
                                        class: {
                                          "red font-weight-bold":
                                            _vm.value.name3.length == 30
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.value.name3.length
                                            )
                                          }
                                        }),
                                        _vm._v(" / 30")
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-4" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate:date",
                                        value:
                                          !!_vm.value.birthday &&
                                          !!_vm.value.birthday.length,
                                        expression:
                                          "!!value.birthday && !!value.birthday.length",
                                        arg: "date"
                                      }
                                    ],
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "birthday" }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "date",
                                        min: "1901-12-14",
                                        max: new Date()
                                          .toISOString()
                                          .split("T")[0],
                                        name: "birthday",
                                        placeholder: _vm.$translate(
                                          "Ceres::Template.addressBirthdatePlaceholder"
                                        ),
                                        id: "txtBirthdate" + _vm._uid
                                      },
                                      domProps: { value: _vm.value.birthday },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "birthday",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "txtBirthdate" + _vm._uid
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.transformTranslation(
                                                "Ceres::Template.addressBirthdate",
                                                "de",
                                                "billing_address.birthday"
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.value.countryId != 1
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-4" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate:text",
                                              value: _vm.value.countryId != 1,
                                              expression: "value.countryId!=1",
                                              arg: "text"
                                            }
                                          ],
                                          staticClass: "input-unit",
                                          attrs: { "data-model": "telephone" }
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "text",
                                              name: "telephone",
                                              id: "txtTelephone" + _vm._uid
                                            },
                                            domProps: {
                                              value: _vm.value.telephone
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.emitInputEvent(
                                                  "telephone",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "txtTelephone" + _vm._uid
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.transformTranslation(
                                                      "Ceres::Template.addressTelephone",
                                                      "de",
                                                      "billing_address.phoneNumber"
                                                    )
                                                  ) +
                                                  " *\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.value.countryId != 1
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-8" },
                                    [
                                      _c("div", { staticClass: "phoneHint" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Woerner::Template.phoneSentence"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-8" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-unit",
                                    attrs: {
                                      "data-validate": "text",
                                      "data-model": "address1"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "street",
                                        autocomplete: "address-line1",
                                        id: "txtStreet" + _vm._uid,
                                        maxlength: "30"
                                      },
                                      domProps: { value: _vm.value.address1 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "address1",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "txtStreet" + _vm._uid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressStreet"
                                            )
                                          ) + "*"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.value.address1
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-right d-block m--t-1",
                                        class: {
                                          "red font-weight-bold":
                                            _vm.value.address1.length == 30
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.value.address1.length
                                            )
                                          }
                                        }),
                                        _vm._v(" / 30")
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-unit",
                                    attrs: {
                                      "data-validate": "text",
                                      "data-model": "address2"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "housenumber",
                                        autocomplete: "address-line2",
                                        id: "txtNumber" + _vm._uid,
                                        maxlength: "5"
                                      },
                                      domProps: { value: _vm.value.address2 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "address2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "txtNumber" + _vm._uid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.addressNumber"
                                            )
                                          ) + "*"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.value.address2
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-right d-block m--t-1",
                                        class: {
                                          "red font-weight-bold":
                                            _vm.value.address2.length == 5
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.value.address2.length
                                            )
                                          }
                                        }),
                                        _vm._v(" / 5")
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-unit",
                                    attrs: { "data-model": "address3" }
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "text",
                                        name: "decorateAddress",
                                        id: "decorateAddress0" + _vm._uid,
                                        maxlength: "30"
                                      },
                                      domProps: { value: _vm.value.address3 },
                                      on: {
                                        input: function($event) {
                                          return _vm.emitInputEvent(
                                            "address3",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "decorateAddress0" + _vm._uid
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.transformTranslation(
                                                "Ceres::Template.addressAdditionalAddress1",
                                                "de",
                                                "billing_address.address3"
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.value.address3
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-right d-block m--t-1",
                                        class: {
                                          "red font-weight-bold":
                                            _vm.value.address3.length == 30
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.value.address3.length
                                            )
                                          }
                                        }),
                                        _vm._v(" / 30")
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-unit",
                                attrs: {
                                  "data-validate": "text",
                                  "data-model": "postalCode"
                                }
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    type: "text",
                                    name: "zip",
                                    id: "txtZip" + _vm._uid
                                  },
                                  domProps: { value: _vm.value.postalCode },
                                  on: {
                                    input: function($event) {
                                      return _vm.emitInputEvent(
                                        "postalCode",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "txtZip" + _vm._uid } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressZip"
                                        )
                                      ) + "*"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-unit",
                                attrs: {
                                  "data-validate": "text",
                                  "data-model": "town"
                                }
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    type: "text",
                                    name: "town",
                                    id: "txtPlace" + _vm._uid
                                  },
                                  domProps: { value: _vm.value.town },
                                  on: {
                                    input: function($event) {
                                      return _vm.emitInputEvent(
                                        "town",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "txtPlace" + _vm._uid } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressPlace"
                                        )
                                      ) + "*"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._t("custom-address-fields")
                        ]
                  ]
            ]
          : [
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.value.gender === "company"
                      ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "input-unit",
                              attrs: {
                                "data-validate": "text",
                                "data-model": "name1"
                              }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "company",
                                  id: "txtCompany" + _vm._uid,
                                  "data-autofocus": "",
                                  maxlength: "30"
                                },
                                domProps: { value: _vm.value.name1 },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "name1",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtCompany" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressCompany"
                                      )
                                    ) + "*"
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.value.name1
                            ? _c(
                                "small",
                                {
                                  staticClass: "text-right d-block m--t-1",
                                  class: {
                                    "red font-weight-bold":
                                      _vm.value.name1.length == 30
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.value.name1.length)
                                    }
                                  }),
                                  _vm._v(" / 30")
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.value.gender === "company"
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-sm-6" },
                          [
                            [
                              3,
                              44,
                              7,
                              9,
                              11,
                              12,
                              10,
                              13,
                              16,
                              15,
                              54,
                              18,
                              33,
                              17,
                              19,
                              21,
                              2,
                              23,
                              22,
                              41,
                              24,
                              26,
                              27,
                              8,
                              6,
                              14,
                              5
                            ].includes(_vm.selectedCountry.id)
                              ? [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate:regex",
                                          value:
                                            _vm.vatnumberValidateExpression,
                                          expression:
                                            "vatnumberValidateExpression",
                                          arg: "regex"
                                        }
                                      ],
                                      staticClass: "input-unit",
                                      attrs: { "data-model": "vatNumber" }
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "text",
                                          name: "vatNumber",
                                          id:
                                            "txtVatNumber" +
                                            _vm.value.countryId,
                                          "data-validate-ref":
                                            _vm.vatnumberValidateExpression,
                                          "data-autofocus": ""
                                        },
                                        domProps: {
                                          value: _vm.value.vatNumber
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.emitInputEvent(
                                              "vatNumber",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for:
                                              "txtVatNumber" +
                                              _vm.value.countryId
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.transformTranslation(
                                                  "Ceres::Template.addressVatNumber",
                                                  "de",
                                                  "delivery_address.vatNumber"
                                                )
                                              ) +
                                              "  *\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input-unit",
                                        attrs: { "data-model": "vatNumber" }
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "text",
                                            name: "vatNumber",
                                            id:
                                              "txtVatNumber" +
                                              _vm.value.countryId,
                                            "data-autofocus": ""
                                          },
                                          domProps: {
                                            value: _vm.value.vatNumber
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.emitInputEvent(
                                                "vatNumber",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for:
                                                "txtVatNumber" +
                                                _vm.value.countryId
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.transformTranslation(
                                                    "Ceres::Template.addressVatNumber",
                                                    "de",
                                                    "delivery_address.vatNumber"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: true,
                              expression: "true",
                              arg: "text"
                            }
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "name2" }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "firstName",
                              id: "txtFirstName" + _vm._uid,
                              "data-autofocus": "",
                              maxlength: "30"
                            },
                            domProps: { value: _vm.value.name2 },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "name2",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtFirstName" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressFirstName"
                                  )
                                ) + "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.value.name2
                        ? _c(
                            "small",
                            {
                              staticClass: "text-right d-block m--t-1",
                              class: {
                                "red font-weight-bold":
                                  _vm.value.name2.length == 30
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.value.name2.length)
                                }
                              }),
                              _vm._v(" / 30")
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: true,
                              expression: "true",
                              arg: "text"
                            }
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "name3" }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "lastName",
                              id: "txtLastName" + _vm._uid,
                              maxlength: "30"
                            },
                            domProps: { value: _vm.value.name3 },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "name3",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtLastName" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressLastName"
                                  )
                                ) + "* "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.value.name3
                        ? _c(
                            "small",
                            {
                              staticClass: "text-right d-block m--t-1",
                              class: {
                                "red font-weight-bold":
                                  _vm.value.name3.length == 30
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.value.name3.length)
                                }
                              }),
                              _vm._v(" / 30")
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.value.countryId != 1
                      ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.value.countryId != 1,
                                  expression: "value.countryId!=1",
                                  arg: "text"
                                }
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "telephone" }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  name: "telephone",
                                  id: "txtTelephone" + _vm._uid
                                },
                                domProps: { value: _vm.value.telephone },
                                on: {
                                  input: function($event) {
                                    return _vm.emitInputEvent(
                                      "telephone",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtTelephone" + _vm._uid } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.transformTranslation(
                                          "Ceres::Template.addressTelephone",
                                          "de",
                                          "delivery_address.phoneNumber"
                                        )
                                      ) +
                                      " *\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.value.countryId != 1
                      ? _c("div", { staticClass: "col-12 col-sm-8" }, [
                          _c("div", { staticClass: "phoneHint" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Woerner::Template.phoneSentence"
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.isParcelOrOfficeAvailable
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              name: "togglePickup",
                              id: "showPickup" + _vm._uid
                            },
                            domProps: { checked: _vm.value.showPickupStation },
                            on: {
                              change: function($event) {
                                return _vm.togglePickupStation(
                                  $event.target.checked
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "showPickup" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressToPickupStation"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-8" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-validate": "text",
                            "data-model": "address1"
                          }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "street",
                              autocomplete: "address-line1",
                              id: "txtStreet" + _vm._uid,
                              maxlength: "30"
                            },
                            domProps: { value: _vm.value.address1 },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "address1",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtStreet" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressStreet"
                                  )
                                ) + "*"
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-validate": "text",
                            "data-model": "address2"
                          }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "housenumber",
                              autocomplete: "address-line2",
                              id: "txtNumber" + _vm._uid
                            },
                            domProps: { value: _vm.value.address2 },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "address2",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtNumber" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressNumber"
                                  )
                                ) + "*"
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" }
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "text",
                              name: "decorateAddress",
                              id: "decorateAddress0" + _vm._uid,
                              maxlength: "30"
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress1",
                                      "de",
                                      "delivery_address.address3"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.value.address3
                        ? _c(
                            "small",
                            {
                              staticClass: "text-right d-block m--t-1",
                              class: {
                                "red font-weight-bold":
                                  _vm.value.address3.length == 30
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.value.address3.length)
                                }
                              }),
                              _vm._v(" / 30")
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: {
                        "data-validate": "text",
                        "data-model": "postalCode"
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "text",
                          name: "zip",
                          id: "txtZip" + _vm._uid
                        },
                        domProps: { value: _vm.value.postalCode },
                        on: {
                          input: function($event) {
                            return _vm.emitInputEvent(
                              "postalCode",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.addressZip")) +
                            "*"
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: { "data-validate": "text", "data-model": "town" }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "text",
                          name: "town",
                          id: "txtPlace" + _vm._uid
                        },
                        domProps: { value: _vm.value.town },
                        on: {
                          input: function($event) {
                            return _vm.emitInputEvent(
                              "town",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressPlace")
                          ) + "*"
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._t("custom-address-fields")
              ]
            ],
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-4" },
          [
            _c("country-select", {
              attrs: {
                "selected-country-id": _vm.value.countryId,
                "selected-state-id": _vm.value.stateId,
                "address-type": _vm.addressType
              },
              on: {
                "country-changed": function($event) {
                  return _vm.onSelectedCountryChanged($event)
                },
                "state-changed": function($event) {
                  return _vm.emitInputEvent("stateId", $event)
                }
              }
            })
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-8" }, [
      _c("div", { staticClass: "phoneHint" }, [
        _vm._v("Phone number is only used for delivery inquieries.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }